import { AxiosResponse } from "axios";
import { IRawPagedResponse, IRawPagedResponse3, PagedResponse } from "./ApiModels";

export class ApiHelper
{
    public static toODataSelect<TResponse>(responseType: new () => TResponse): string
    {
        const responseInstance = new responseType();
        const oDataSelect = Object.entries(responseInstance as {}).map(i => i[0]).join(",");
        return oDataSelect;
    }

    public static toTypedResponse<TResponse>(response: any, mapResponse?: (response: any) => TResponse, mapItem?: (item: any) => any): TResponse
    {
        const isPaged = typeof (response) == 'object' && (('@odata.nextLink' in response) || ('OdataNextLink' in response) || ('NextToken' in response));
        const mapItemOrDefault = (mapItem ? mapItem : (item: any) => item);
        let mappedResponse: TResponse;

        if (mapResponse)
        {
            mappedResponse = mapResponse(response);
        }
        else if (Array.isArray(response))
        {
            mappedResponse = response.map(item => mapItemOrDefault(item)) as TResponse;
        }
        else if (isPaged)
        {
            let responseValue: [] = (response.Value ?? response.value ?? response.Results ?? response.results ?? []);
            if (typeof (responseValue) == 'string')
            {
                responseValue = JSON.parse(responseValue);
            }
            if (!Array.isArray(responseValue))
            {
                throw 'Response must be an array or a JSON string containing an array.';
            }

            const nextLink = (response["@odata.nextLink"] || response["OdataNextLink"] || response["NextToken"] || null);
            const skipToken = PagedResponse.fromNextLinkToSkipToken(nextLink);
            const pagedResponse =
            {
                skipToken: skipToken,
                value: responseValue.map(item => mapItemOrDefault(item)),
            };
            mappedResponse = pagedResponse as TResponse;
        }
        else
        {
            mappedResponse = mapItemOrDefault(response);
        }
        return mappedResponse;
    }
}
